import React from 'react'

import {AccommodationOverlayContentLoadable} from './Loadable'

export const AccommodationOverlayContent = () => (
  <AccommodationOverlayContentLoadable />
)
